import {ContractorInvoicesDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'UPDATE_CONTRACTOR_INVOICE';

export async function updateContractorInvoice(
    userData: Record<string, string>,
    updatedContractorInvoice: Record<string, any>,
    id: string
) {

    try {
        return await ContractorInvoicesDao.updateContractorInvoice(userData.userToken, updatedContractorInvoice, id);
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Erreur lors de la mis à jour du fournisseur',
            error: error
        });
    }
}
